/**
 * Device Utilities for Fingerprinting and Session Management
 */
/**
 * Device Utilities for Fingerprinting and Session Management
 */

const DEVICE_ID_KEY = 'webadmin_device_id';

/**
 * Get or generate a persistent device ID
 */
export function getDeviceId(): string {
  let deviceId = localStorage.getItem(DEVICE_ID_KEY);
  if (!deviceId) {
    deviceId = crypto.randomUUID();
    localStorage.setItem(DEVICE_ID_KEY, deviceId);
  }
  return deviceId;
}

/**
 * Nhận diện hệ điều hành từ UserAgent
 */
function getOSName(ua: string): string {
  if (ua.includes('Windows')) {
    const match = ua.match(/Windows NT ([\d.]+)/);
    return match ? `Windows ${match[1]}` : 'Windows';
  }
  if (ua.includes('Macintosh')) return 'macOS';
  if (ua.includes('Linux')) return 'Linux';
  return 'Unknown OS';
}

/**
 * Nhận diện chi tiết tên Trình duyệt từ UserAgent
 */
function getBrowserName(ua: string): string {
  if (ua.includes('Chrome') && !ua.includes('Edg')) return 'Chrome';
  if (ua.includes('Firefox')) return 'Firefox';
  if (ua.includes('Safari') && !ua.includes('Chrome')) return 'Safari';
  if (ua.includes('Edg')) return 'Edge';
  if (ua.includes('Opera') || ua.includes('OPR')) return 'Opera';
  return 'Unknown Browser';
}

/**
 * Get basic device info (name and OS) from UserAgent
 */
export function getDeviceInfo() {
  const ua = navigator.userAgent;
  const osVersion = getOSName(ua);
  const deviceName = getBrowserName(ua);

  return {
    device_id: getDeviceId(),
    device_name: deviceName,
    os_version: osVersion,
  };
}
